if (!customElements.get('quick-filter-nav')) {
  customElements.define(
    'quick-filter-nav',
    class QuickFilterNav extends window.BAO.CustomElement {
      constructor () {
        super()

        this.sectionId = this.dataset.sectionId

        this.onClick = this.onClick.bind(this)
        this.resync = this.resync.bind(this)
      }

      setupListeners () {
        super.setupListeners()

        this.listeners.add(this, 'click', this.onClick)
        this.listeners.add(window, 'facet-filters:updated', this.resync)
        this.listeners.add(window, 'popstate', this.resync)
      }

      get grid () {
        return this.externalEls.facetFiltersForm?.element
      }

      onClick (event) {
        const link = event.target.closest(this.els.link.selector)
        if (!link) return

        event.preventDefault()

        if (this.grid) {
          this.grid.renderPage(link.href)
        } else {
          window.location.href = link.href
        }
      }

      resync () {
        if (!this.sectionId) return

        const url = new URL(window.location.href)
        url.searchParams.set('section_id', this.sectionId)

        fetch(url.toString())
          .then(response => response.text())
          .then(html => {
            const doc = new DOMParser().parseFromString(html, 'text/html')
            const newButtons = doc.querySelector('quick-filter-nav')

            if (newButtons) {
              this.innerHTML = newButtons.innerHTML
              // The links just got replaced, so refresh the cached lookup to match.
              this.els = this.getElements(this._getElementIdentifiers())
            }
          })
      }
    }
  )
}
